import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

/**
 * Animated number counter. Counts from 0 → value when scrolled into view.
 * - decimals: force decimal display
 * - prefix/suffix: rendered around the number
 */
export function Counter({ value, prefix = '', suffix = '', decimals = 0, className = '' }) {
  const ref = useRef(null);
  const [val, setVal] = useState(0);
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { setVal(value); return; }
    const node = ref.current;
    if (!node) return;
    let started = false;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started) {
        started = true;
        const obj = { v: 0 };
        gsap.to(obj, {
          v: value,
          duration: 1.6,
          ease: 'power2.out',
          onUpdate: () => setVal(obj.v),
        });
        obs.disconnect();
      }
    }, { threshold: 0.4 });
    obs.observe(node);
    return () => obs.disconnect();
  }, [value]);
  const display = decimals > 0 || !Number.isInteger(value)
    ? val.toFixed(decimals || 1)
    : Math.round(val).toString();
  return (
    <span ref={ref} className={`tabular-nums ${className}`}>
      {prefix}{display}{suffix}
    </span>
  );
}
